import React, { useEffect, useRef, useState } from "react";

// Libraries
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { m } from "framer-motion";

// Components
import { Header, HeaderNav, Menu } from "../Components/Header/Header";
import Buttons from "../Components/Button/Buttons";
import { fadeIn, fadeInUp } from "../Functions/GlobalAnimations";

import SocialIcons from "../Components/SocialIcon/SocialIcons";
import CustomIconWithText from "../Components/CustomIconWithText/CustomIconWithText";
import Instagram from "../Components/Instagram/Instagram";
import FancyTextBox from "../Components/FancyTextBox/FancyTextBox";
import Tab03 from "../Components/Tab/Tab03";
import InfoBannerStyle01 from "../Components/InfoBanner/InfoBannerStyle01";
import SideButtons from "../Components/SideButtons";
import CustomModal from "../Components/CustomModal";
import ImageGallery from "../Components/ImageGallery/ImageGallery";

const SocialIconsData = [
  {
    color: "#828282",
    link: "https://www.instagram.com/broadwayhotpot/",
    icon: "fab fa-instagram",
  },
  // {
  //   color: '#828282',
  //   link: 'https://www.yelp.com/',
  //   icon: 'fab fa-yelp',
  // },
  {
    color: "#828282",
    link: "https://www.xiaohongshu.com/user/profile/5c783ddb0000000017011fbf",
    alt: "xiaohongshu",
  },
];

// broths, meat, vegetable, seafood, supreme, drinks, snacks, skewer
const NEW_BADGE = {
  title: "NEW",
  color: "#70a967",
};
const HOT_BADGE = {
  title: "HOT",
  color: "#d74a3a",
};
const VEGETARIAN_BADGE = {
  title: "VEG",
  color: "#70a967",
};
const SHELLFISH_BADGE = {
  title: "FISH",
  color: "#70a967",
};
const NUT_BADGE = {
  title: "NUT",
  color: "#70a967",
};
const GLUTEN_FREE_BADGE = {
  title: "GF",
  color: "#70a967",
};

const LandingPage = (props) => {
  const [language, setLanguage] = useState("EN");

  const SwiperData = [
    {
      img: "/assets/img/hero-hotpot.webp",
      title: language === "EN" ? "Delicious Hotpot" : "火锅盛宴",
      subtitle: language === "EN" ? "A Unique Experience" : "独特的体验",
      to: "/#menu",
    },
    {
      img: "/assets/img/ktv-1.jpg",
      title: language === "EN" ? "Karaoke Room" : "KTV包间",
      subtitle: language === "EN" ? "Let's Get Party Started" : "派对开始啦",
      to: "/#karaoke-room",
    },
    {
      img: "/assets/img/hero-bar.webp",
      title: language === "EN" ? "Full Bar" : "全酒吧服务",
      subtitle: language === "EN" ? "Enjoy the Vibe" : "享受此时此刻",
      to: "/#menu",
    },
  ];

  const RoyaltyProgramData = [
    {
      icon: "line-icon-Coins",
      title: language === "EN" ? "Points" : "积分",
      content:
        language === "EN"
          ? "Earn points with every dollar you spend with us"
          : "每消费一美元都可赚取积分",
    },
    {
      icon: "line-icon-Coins-3",
      title: language === "EN" ? "Promotions" : "优惠福利",
      content:
        language === "EN"
          ? "Enjoy exclusive perks & discounts"
          : "尽享专属福利和优惠",
    },
    {
      icon: "line-icon-Birthday-Cake",
      title: language === "EN" ? "Birthday Rewards" : "生日",
      content:
        language === "EN"
          ? "Celebrate your special day with us and enjoy your birthday rewards!"
          : "在我们这里庆祝您的生日，享受生日礼遇！",
    },
    {
      icon: "line-icon-Information",
      title: language === "EN" ? "Learn More" : "了解更多",
      content:
        language === "EN" ? "More details coming soon" : "敬请期待更多细节",
      //content:language=== "EN"? 'Ask our staff for more details':"",
    },
  ];

  const ReservationSectionData = [
    {
      img: "/assets/img/reservation-dining.webp",
      title: language === "EN" ? "Authentic Hotpot Experience" : "火锅体验",
      content:
        language === "EN"
          ? "Reserve a table for your next, or very first hotpot experience with us"
          : "预约您的下一次/首次火锅体验",
      price: "Dining Area",
      btnName: language === "EN" ? "Make a Reservation" : "预约",
      btnLink: "https://yelp.to/AzRc-Gmu79",
    },
    {
      img: "/assets/img/ktv-1.jpg",
      title: language === "EN" ? "Party like King & Queen" : "尽情派对",
      content:
        language === "EN"
          ? "Book our Karaoke room today with professional lights and devices"
          : "立即预定卡拉OK包间",
      price: "Karaoke Room",
      btnName: language === "EN" ? "Make a Reservation" : "预约",
      scrollTo: "karaokeRoomRef",
    },
    {
      img: "/assets/img/hero-bar.webp",
      title: language === "EN" ? "Enjoy the vibe" : "尽享Fells Point氛围",
      content:
        language === "EN"
          ? "Not feeling a full hotpot buffet experience today? Not a problem! Grab a seat at our bar and check what we offer!"
          : "今天不想吃火锅？没问题！来我们的吧台坐坐，看看我们提供的特别选择吧！",
      price: "Bar Area",
      btnName: language === "EN" ? "No reservation needed" : "无需预约",
    },
  ];

  const TabData03 = [
    {
      tabTitle: "BROTH",
      tabicons: "",
      activities: [
        {
          price: "",
          img: "/assets/img/menu/soup_base/nourishing_herbal.png",
          title: "Nourishing Herbal",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/soup_base/pork_bone.png",
          title: "Pork Bone",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/soup_base/thai_tom_yum.png",
          title: "Thai Tom Yum",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/soup_base/umami_mushroom.png",
          title: "Umami Mushroom",
          content: "",
          author: "",
          badges: [VEGETARIAN_BADGE],
        },
        {
          price: "",
          img: "/assets/img/menu/soup_base/buttery_spicy.png",
          title: "Buttery Spicy",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/soup_base/fish_maw_chicken.png",
          title: "Fish Maw Chicken",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/soup_base/house_tomato.png",
          title: "House Tomato",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "And More...",
          content: "",
          author: "",
        },
      ],
    },
    {
      tabTitle: "MEAT",
      tabicons: "",
      activities: [
        {
          price: "",
          img: "/assets/img/menu/meat/supreme_angus_beef_brisket.png",
          title: "Supreme Angus Beef Brisket",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/meat/usda_prime_rib_slice.png",
          title: "USDA Prime Rib Slice",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/meat/new_zealand_lamb_brisket.png",
          title: "New Zealand Lamb Brisket",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/meat/pork_belly.png",
          title: "Pork Belly",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/meat/thin_sliced_chicken_breast.png",
          title: "Thin Sliced Chicken Breast",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/meat/spam.png",
          title: "Spam",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/meat/beef_tongue.png",
          title: "Beef Tongue",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "And More...",
          content: "",
          author: "",
        },
      ],
    },
    {
      tabTitle: "VEGETARIAN",
      tabicons: "",
      activities: [
        {
          price: "",
          img: "",
          title: "Napa Cabbage",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Baby Bok Choy",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Fried Doughnut Sticks",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Oyster Mushroom",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Sliced Pumpkin",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Sliced Lotus Root",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Baby Bamboo Shoots",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "And More...",
          content: "",
          author: "",
        },
      ],
    },
    {
      tabTitle: "SEAFOOD",
      tabicons: "",
      activities: [
        {
          price: "",
          img: "",
          title: "Shrimp",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Calamari",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Baby Octopus",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Mussels",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Clams",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Scallop",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "Fish Fillet",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "",
          title: "And More...",
          content: "",
          author: "",
        },
      ],
    },
    // {
    //   tabTitle: "DRINKS",
    //   tabicons: "",
    //   activities: [
    //     {
    //       price: "$2.50",
    //       img: "https://via.placeholder.com/73x73",
    //       title: "Soft Drink",
    //       content: "",
    //       author: "",
    //     },
    //     {
    //       price: "$8.00",
    //       img: "https://via.placeholder.com/73x73",
    //       title: "Coconut Mango Bliss",
    //       content: "",
    //       author: "",
    //     },
    //     {
    //       price: "$3.50",
    //       img: "https://via.placeholder.com/73x73",
    //       title: "Herbal Tea",
    //       content: "",
    //       author: "",
    //     },
    //     {
    //       price: "$8.00",
    //       img: "https://via.placeholder.com/73x73",
    //       title: "Grapefruit Flamingo",
    //       content: "",
    //       author: "",
    //     },
    //     {
    //       price: "$7.00",
    //       img: "https://via.placeholder.com/73x73",
    //       title: "Sunset Lemonade",
    //       content: "",
    //       author: "",
    //     },
    //     {
    //       price: "$7.00",
    //       img: "https://via.placeholder.com/73x73",
    //       title: "Jasmine Green Milk Boba Tea",
    //       content: "",
    //       author: "",
    //     },
    //     {
    //       price: "$8.00",
    //       img: "https://via.placeholder.com/73x73",
    //       title: "Zero Piña Coladas",
    //       content: "",
    //       author: "",
    //     },
    //     {
    //       price: "$3.5",
    //       img: "https://via.placeholder.com/73x73",
    //       title: "Plum Juice",
    //       content: "",
    //       author: "",
    //     },
    //   ],
    // },
    {
      tabTitle: "SKEWERS",
      tabicons: "",
      activities: [
        {
          price: "",
          img: "/assets/img/menu/skewer/beef_skewer.png",
          title: "Beef Skewer",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/skewer/chicken_skewer.png",
          title: "Chicken Skewer",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/skewer/lamb_skewer.png",
          title: "Lamb Skewer",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/skewer/mini_sausage.png",
          title: "Mini Sausage Skewer",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/skewer/beef_ball.png",
          title: "Beef Ball Skewer",
          content: "",
          author: "",
        },
        {
          price: "",
          img: "/assets/img/menu/skewer/fish_tofu.png",
          title: "Fish Tofu Skewer",
          content: "",
          author: "",
        },
      ],
    },
    // {
    //   tabTitle: "COCKTAIL",
    //   tabicons: "",
    //   activities: [],
    // },
    // {
    //   tabTitle: "SUPREME",
    //   tabicons: "",
    //   activities: [],
    // },
  ];

  const EventData = [
    {
      src: "/assets/img/promoAndEvent/creative-contest-en.png",
      title: "Hotpot Hacks Challenge",
    },
    {
      src: "/assets/img/promoAndEvent/creative-contest-detail-en.png",
      title: "Hotpot Hacks Challenge Detail",
    },
    {
      src: "/assets/img/promoAndEvent/creative-contest-cn.jpg",
      title: "火锅脑洞大赛",
    },
    {
      src: "/assets/img/promoAndEvent/creative-contest-detail-cn.jpg",
      title: "火锅脑洞大赛细则",
    },
  ];

  const DrinkSpecialData = [
    {
      src: "/assets/img/promoAndEvent/margarita-tue.jpg",
      title: "Margarita Tuesday",
    },
    {
      src: "/assets/img/promoAndEvent/wine-wed.png",
      title: "Wine Wednesday",
    },
    {
      src: "/assets/img/promoAndEvent/somaek.jpg",
      title: "Somaek Weekend",
    },
  ];

  const MembershipTopupPromoData = [
    {
      src: "/assets/img/promoAndEvent/membership_promo_detail_en.jpg",
      title: "Membership Top-Up Promo Detail",
    },
    {
      src: "/assets/img/promoAndEvent/membership_promo_detail_cn.jpg",
      title: "会员充值活动细则",
    },
  ];

  // function useMediaQuery(query) {
  //   const [matches, setMatches] = useState(window.matchMedia(query).matches);

  //   useEffect(() => {
  //     const media = window.matchMedia(query);
  //     const listener = () => setMatches(media.matches);
  //     media.addListener(listener);
  //     return () => media.removeListener(listener);
  //   }, [query]);

  //   return matches;
  // }

  // actual site
  // const isSmallScreen = useMediaQuery("(max-width: 768px)");
  // const isMediumScreen = useMediaQuery("(max-width: 992px)");
  const [searchParams, setSearchParams] = useSearchParams();
  const utmCampaign = searchParams.get("utm_campaign");
  const initialSection = searchParams.get("section");
  const [showLandingPopup, setShowLandingPopup] = useState(false);

  const swiperRef = useRef(null);

  useEffect(() => {
    let links = document.querySelectorAll(".section-link");

    links.forEach((item) => {
      item.addEventListener("click", () => {
        document.querySelector(".navbar-toggler:not(.collapsed)")?.click();
      });
    });
  }, []);

  const historyRef = useRef(null);
  const aboutUsRef = useRef(null);
  const menuRef = useRef(null);
  const karaokeRoomRef = useRef(null);
  const promoRef = useRef(null);
  const royaltyRef = useRef(null);
  const reservationRef = useRef(null);
  const findUsRef = useRef(null);

  const fancyTextBox = [
    {
      title: language === "EN" ? "Karaoke Room" : "卡拉OK",
      description:
        language === "EN"
          ? "Your private room with Karaoke device to party your way. Book your room today!"
          : "带卡拉OK设备的私人包间，让你尽情派对！立即预订你的专属包间！",
      hoverImg: "/assets/img/ktv-3.webp",
      to: karaokeRoomRef,
    },
    {
      title: language === "EN" ? "Hotpot" : "火锅",
      description:
        language === "EN"
          ? "We are first to bring a unique hotpot experience to Baltimore City. Check what we offer."
          : "我们是首家将独特火锅体验带到巴尔的摩市的餐厅，快来看看我们为你准备的精彩体验。",
      hoverImg: "/assets/img/about-us-hotpot.webp",
      to: menuRef,
    },
    {
      title: language === "EN" ? "Bar" : "酒吧",
      description:
        language === "EN"
          ? "Check our special cocktail menu"
          : "查看我们的特色鸡尾酒菜单",
      hoverImg: "/assets/img/hero-bar.webp",
      to: menuRef,
    },
    {
      title: language === "EN" ? "Royalty Program" : "尊享会员计划",
      description:
        language === "EN"
          ? "Get rewards for every visit! Earn points and enjoy exclusive perks, discounts, and special offers just for you. Coming Soon!"
          : "赚取积分，享受专属福利、折扣和特别优惠。即将推出",
      hoverImg: "/assets/img/building-history.webp",
      to: null,
    },
  ];

  const handleNavClick = (to) => {
    switch (to) {
      case "/#":
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        break;
      case "/#history":
        historyRef.current.scrollIntoView({
          behavior: "smooth",
        });
        break;
      case "/":
        window.location.href = "/";
        break;
      case "/about-us":
        window.location.href = "/about-us";
        break;
      case "/#menu":
      case "menu":
        menuRef.current.scrollIntoView({
          behavior: "smooth",
        });
        break;
      case "/#karaoke-room":
      case "karaoke-room":
        karaokeRoomRef.current.scrollIntoView({
          behavior: "smooth",
        });
        break;
      case "/#promo":
      case "promo":
        promoRef.current.scrollIntoView({
          behavior: "smooth",
        });
        break;
      case "/#royalty-program":
      case "royalty-program":
        royaltyRef.current.scrollIntoView({
          behavior: "smooth",
        });
        break;
      case "/#reservation":
      case "reservation":
        reservationRef.current.scrollIntoView({
          behavior: "smooth",
        });
        break;
      case "/#find-us":
      case "find-us":
        findUsRef.current.scrollIntoView({
          behavior: "smooth",
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (searchParams.get("utm_campaign") !== "HACK2025MAR") {
        setShowLandingPopup(true);
      }
    }, 1500);
    setTimeout(() => {
      if (searchParams.get("section")) {
        handleNavClick(searchParams.get("section"));
      }
    }, 500);
  }, [searchParams]);

  useEffect(() => {
    setTimeout(() => {
      if (initialSection === "karaoke") {
        karaokeRoomRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 500);
  });

  // karaoke reservation button
  const [karaokeRoom, setKaraokeRoom] = useState("queen");
  const handleKaraokeRoomChange = (e) => {
    setKaraokeRoom(e.target.value);
  };

  return (
    <>
      <SideButtons
        menuRef={menuRef}
        karaokeRoomRef={karaokeRoomRef}
        language={language}
      />
      {/* Header Start */}
      <Header
        topSpace={{ desktop: true }}
        type="reverse-scroll border-b border-[#ffffff1a] bg-white"
      >
        <HeaderNav
          theme="white"
          fluid="fluid"
          className="py-[0px] px-[35px] md:py-[15px] md:pr-[15px] sm:px-0 md:pl-0"
          containerClass="xs:pr-0"
        >
          <Col
            className="col-8 col-lg-2 me-auto ps-lg-0 xs:!p-0"
            style={{ display: "flex", alignItems: "center", gap: 10 }}
          >
            <Link
              aria-label="header home link"
              className="flex items-center"
              to="/"
            >
              <Navbar.Brand className="inline-block p-0 m-0">
                <img
                  className="default-logo"
                  loading="lazy"
                  src="/assets/img/logo.png"
                  alt="logo"
                />
                <img
                  className="alt-logo"
                  loading="lazy"
                  src="/assets/img/logo.png"
                  alt="logo"
                />
                <img
                  className="mobile-logo"
                  loading="lazy"
                  src="/assets/img/logo.png"
                  alt="logo"
                />
              </Navbar.Brand>
            </Link>
            <div
              onClick={() =>
                setLanguage((prev) => (prev === "EN" ? "CN" : "EN"))
              }
              style={{ cursor: "pointer" }}
              ariaLabel={
                language === "EN" ? "切换中文" : "Translate to English"
              }
            >
              {language === "EN" ? "中" : "EN"}
            </div>
          </Col>
          <Navbar.Toggle className="order-last md:ml-[25px] sm:ml-[17px] xs:mr-[17px]">
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
          </Navbar.Toggle>
          <Navbar.Collapse className="justify-end col-auto menu-order px-lg-0">
            <Menu
              {...props}
              historyRef={historyRef}
              aboutUsRef={aboutUsRef}
              menuRef={menuRef}
              karaokeRoomRef={karaokeRoomRef}
              promoRef={promoRef}
              royaltyRef={royaltyRef}
              reservationRef={reservationRef}
              findUsRef={findUsRef}
              socialIconsData={SocialIconsData}
              language={language}
            />
          </Navbar.Collapse>
          <Col className="col-auto text-end pe-0 font-size-0 !pl-[22px] xs:hidden">
            <SocialIcons
              theme="social-icon-style-01 block text-center"
              iconColor="dark"
              size="xs"
              data={SocialIconsData}
            />
          </Col>
        </HeaderNav>
        {/* <section className="bg-red-500 py-[25px]">
          <Container>
            <Row className="items-center justify-center mb-0">
              <h1 className="font-serif text-white font-medium mb-0 text-center text-lg">
                Check out our LIMITED TIME ONLY{" "}
                <div
                  className="nav-link"
                  onClick={() => handleNavClick("/#royalty-program")}
                  style={{ cursor: "pointer" }}
                >
                  Lunar New Year Membership Top-Up Promotion
                </div>
              </h1>
            </Row>
          </Container>
        </section> */}
      </Header>
      {/* <Header topSpace={{ desktop: true }} type="always-fixed">
        <section className="bg-red-500 py-[25px]">
          <Container>
            <Row className="items-center justify-center mb-0">
              <h1 className="font-serif text-white font-medium mb-0 text-center text-lg">
                Check out our LIMITED TIME ONLY{" "}
                <div
                  className="nav-link"
                  onClick={() => handleNavClick("/#royalty-program")}
                  style={{ cursor: "pointer" }}
                >
                  Lunar New Year Membership Top-Up Promotion
                </div>
              </h1>
            </Row>
          </Container>
        </section>
      </Header> */}
      {/* Header End */}
      {/* Hero Swiper Start */}
      <section>
        <Swiper
          className="slider-nav-dark white-move swiper-pagination-light swiper-pagination-medium h-full md:h-[700px] sm:h-[450px]"
          modules={[Pagination, Autoplay]}
          pagination={false}
          ref={swiperRef}
          slidesPerView={1}
          spaceBetween={0}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
        >
          <div
            onClick={() => swiperRef.current.swiper.slidePrev()}
            className="btn-slider-next -translate-y-1/2 absolute top-1/2 z-[1] left-[40px] text-[40px] text-white h-[50px] w-[50px] leading-[50px] flex justify-center items-center right-inherit cursor-pointer xs:left-[15px]"
          >
            <i className="line-icon-Arrow-OutLeft text-[50px]"></i>
          </div>
          {SwiperData.map((item, i) => {
            return (
              <SwiperSlide
                key={i}
                style={{ backgroundImage: `url(${item.img})` }}
                className="bg-no-repeat	bg-cover	overflow-hidden relative bg-center"
              >
                <div className="absolute h-full w-full top-0 left-0 opacity-50 bg-darkgray"></div>
                <Container className="full-screen sm:h-[450px]">
                  <Row className="h-full justify-center md:h-[700px] sm:h-[450px]">
                    <Col
                      xl={6}
                      sm={7}
                      className="text-center h-full justify-center flex-col relative flex"
                    >
                      <span className="font-serif tracking-[3px] text-xmd text-white opacity-70 uppercase block mb-[45px] sm:mb-[15px]">
                        {item.subtitle}
                      </span>
                      <h1 className="font-serif font-bold text-shadow-extra-large text-[100px] leading-[95px] text-white uppercase tracking-[-4px] mb-[55px] mx-auto sm:mx-0 lg:text-[90px] lg:leading-[90px] md:text-[70px] md:leading-[65px] sm:text-[45px] sm:leading-[43px] sm:tracking-[-1px] sm:mb-[30px] xs:w-[85%]">
                        {item.title}
                      </h1>
                      <div className="inline-block">
                        <Buttons
                          ariaLabel={
                            language === "EN" ? "Discover more" : "了解详情"
                          }
                          onClick={() => {
                            handleNavClick(item.to);
                          }}
                          className="btn-fill btn-fancy drop-shadow-md font-medium font-serif uppercase rounded-[2px] btn-shadow text-[15px] md:mb-[15px]"
                          size="lg"
                          themeColor="#cd9452"
                          color="#fff"
                          title={
                            language === "EN" ? "Discover more" : "了解详情"
                          }
                          type="button"
                        />
                      </div>
                    </Col>
                  </Row>
                </Container>
              </SwiperSlide>
            );
          })}
          <div
            onClick={() => swiperRef.current.swiper.slideNext()}
            className="btn-slider-prev absolute top-1/2 -translate-y-1/2 z-[1] right-[40px] text-[40px] text-white h-[50px] w-[50px] leading-[50px] flex justify-center items-center right-inherit cursor-pointer xs:right-[15px]"
          >
            <i className="line-icon-Arrow-OutRight text-[50px]"></i>
          </div>
        </Swiper>
      </section>
      {/* Hero Swiper End */}
      {/* Info Start */}
      <section
        ref={findUsRef}
        className="py-[160px] overflow-hidden lg:py-[120px] md:py-[95px] sm:py-[80px]"
      >
        <Container
          style={{ display: "flex", flexDirection: "column", gap: 20 }}
        >
          <Row lg={1} sm={1} xs={1}>
            <m.div
              {...{ ...fadeIn, transition: { delay: 0.2 } }}
              className="text-center md:mb-[40px]"
            >
              <i className="feather-map-pin text-[28px] text-[#ca943d] mb-[25px] sm:mb-[10px] block"></i>
              <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                {language === "EN" ? "Find us" : "联系我们"}
              </div>
              <p className="w-[75%] lg:w-full md:w-[60%] sm:w-[75%] mx-auto">
                709 S Broadway, Baltimore, MD 21231
                <br />
                {language === "EN" ? "Phone" : "电话"}: 443-835-1190
              </p>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1544.1136650570124!2d-76.59408201675954!3d39.28309475854989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c80337a9401039%3A0x311f5d74d6f897ef!2sBroadway%20Hotpot%20%26%20Bar!5e0!3m2!1sen!2sus!4v1732245607414!5m2!1sen!2sus"
                width="600"
                height="450"
                style={{ border: 0, margin: 10 }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              />
            </m.div>
          </Row>
          <Row lg={3} sm={3} xs={1}>
            <m.div
              {...{ ...fadeIn, transition: { delay: 0.6 } }}
              className="text-center xs:mb-[40px]"
            >
              <i className="feather-mail text-[28px] text-[#ca943d] mb-[25px] sm:mb-[10px] block"></i>
              <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px] sm:mb-0">
                {language === "EN" ? "Make a reservation" : "预约"}
              </div>
              <p className="w-[70%] lg:w-full mx-auto">
                <Buttons
                  ariaLabel="Book Dining Area"
                  className="w-[190px] btn-fill mx-auto font-medium font-serif rounded-none uppercase mt-[15px] mb-[15px]"
                  themeColor="#cd9452"
                  color="#fff"
                  size="lg"
                  title={
                    language === "EN" ? "Book Hotpot Experience" : "预约火锅"
                  }
                  width={190}
                  href="https://yelp.to/AzRc-Gmu79"
                  target="_blank"
                />
              </p>
              <p className="w-[70%] lg:w-full mx-auto">
                <Buttons
                  ariaLabel="Book Karaoke Room"
                  className="w-[190px] btn-fill mx-auto font-medium font-serif rounded-none uppercase"
                  themeColor="#cd9452"
                  color="#fff"
                  size="lg"
                  title={
                    language === "EN" ? "Book a Karaoke Room" : "预约卡拉OK"
                  }
                  width={190}
                  onClick={() =>
                    karaokeRoomRef.current.scrollIntoView({
                      behavior: "smooth",
                    })
                  }
                  type="button"
                />
              </p>
            </m.div>
            <m.div
              {...{ ...fadeIn, transition: { delay: 0.4 } }}
              className="text-center md:mb-[40px]"
            >
              <i className="feather-phone-call text-[28px] text-[#ca943d] mb-[25px] sm:mb-[10px] block"></i>
              <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                {language === "EN" ? "Follow us" : "关注我们"}
              </div>
              <p className="w-[70%] lg:w-full mx-auto">
                <SocialIcons
                  theme="social-icon-style-01"
                  size="xs"
                  iconColor="dark"
                  className="justify-center text-center"
                  data={SocialIconsData}
                />
              </p>
            </m.div>

            <m.div
              {...{ ...fadeIn, transition: { delay: 0.8 } }}
              className="text-center xs:mb-[40px]"
            >
              <i className="feather-globe text-[28px] text-[#ca943d] text-pink mb-[25px] sm:mb-[10px] block"></i>
              <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                {language === "EN" ? "Restaurant hour" : "营业时间"}
              </div>
              <p className="w-[75%] lg:w-full md:w-[60%] sm:w-[75%] mx-auto">
                {language === "EN" ? "Mon, Tue, Thurs" : "周一周二及周四"}:
                11:30 am - 9:30 pm
                <br />
                <u>
                  {language === "EN"
                    ? "Hotpot last order: 9 pm"
                    : "火锅最后点单时间: 9 pm"}
                </u>
                <br />
                {language === "EN" ? "Wed" : "周三"}: 4:30 pm - 9:30 pm
                <br />
                <u>
                  {language === "EN"
                    ? "Hotpot last order: 9 pm"
                    : "火锅最后点单时间: 9 pm"}
                </u>
                <br />
                {language === "EN" ? "Fri & Sat" : "周五 & 周六"}: 11:30 am - 12
                am
                <br />
                <u>
                  {language === "EN"
                    ? "Hotpot last order: 11:00 pm"
                    : "火锅最后点单时间: 11:00 pm"}
                </u>
                <br />
                {language === "EN" ? "Sun" : "周日"}: 11:30 am - 10:00 pm
                <br />
                <u>
                  {language === "EN"
                    ? "Hotpot last order: 9:30 pm"
                    : "火锅最后点单时间: 9:30 pm"}
                </u>
              </p>
            </m.div>
          </Row>
        </Container>
      </section>
      {/* Info End */}
      {/* Promo Event Start */}
      {/* <section
        ref={promoRef}
        className="border-bottom border-color-extra-light-gray px-[10%] lg:px-0 py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]"
      >
        <Container fluid>
          <Row>
            <Col className="mb-[6%]">
              <h6 className="font-serif text-dark text-center font-medium mb-[25px] lg:mb-[15px]">
                Ongoing Events
              </h6>
            </Col>
          </Row>
          <Row>
            <ImageGallery
              theme="image-gallery-01"
              data={EventData}
              overlay={["#556fff", "#b263e4", "#e05fc4", "#f767a6", "#ff798e"]}
              className=""
              animation={fadeIn}
            />
          </Row>
        </Container>
      </section> */}
      <section className="border-bottom border-color-extra-light-gray px-[10%] lg:px-0 py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]">
        <Container fluid>
          <Row>
            <Col className="mb-[6%]">
              <h6 className="font-serif text-dark text-center font-medium mb-[25px] lg:mb-[15px]">
                Ongoing Drink Special
              </h6>
            </Col>
          </Row>
          <Row>
            <ImageGallery
              theme="image-gallery-01"
              data={DrinkSpecialData}
              overlay={["#556fff", "#b263e4", "#e05fc4", "#f767a6", "#ff798e"]}
              className=""
              animation={fadeIn}
            />
          </Row>
        </Container>
      </section>
      {/* <section
        ref={royaltyRef}
        className="border-bottom border-color-extra-light-gray px-[10%] lg:px-0 py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]"
      >
        <Container fluid>
          <Row>
            <Col className="mb-[6%]">
              <h6 className="font-serif text-dark text-center font-medium mb-[25px] lg:mb-[15px]">
                Membership Top-up Promotion
              </h6>
            </Col>
          </Row>
          <Row>
            <ImageGallery
              theme="image-gallery-01"
              data={MembershipTopupPromoData}
              overlay={["#556fff", "#b263e4", "#e05fc4", "#f767a6", "#ff798e"]}
              className=""
              animation={fadeIn}
            />
          </Row>
        </Container>
      </section> */}
      {/* Promo Event End */}
      {/* Specialty Start */}
      <m.section
        ref={aboutUsRef}
        className="bg-darkgray cover-background overflow-hidden"
        style={{
          backgroundImage: "url(/assets/img/ktv-3.webp)",
        }}
        {...fadeIn}
      >
        <Container fluid className="px-0">
          <FancyTextBox
            grid="row row-cols-1 row-cols-xl-4 row-cols-sm-2 gx-0 px-0"
            themeColor=""
            className="justify-center"
            theme="fancy-text-box-05"
            data={fancyTextBox}
            animation={fadeIn}
          />
        </Container>
      </m.section>
      {/* Specialty End */}
      {/* Menu Highlight Start */}
      <m.section
        ref={menuRef}
        className="bg-[#f8f4f0] cafe-tab-style-03 py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] cover-background overflow-hidden relative"
        {...fadeIn}
      >
        <Container>
          <Row className="justify-center">
            <Col md={5} className="text-center mb-[84px] xs:mb-[70px]">
              <span className="text-xmd text-basecolor uppercase font-serif font-medium tracking-[1px] block mb-[5px]">
                {language === "EN" ? "Menu Highlights" : "本店特色"}
              </span>
              <h2 className="heading-5 font-serif font-bold uppercase text-darkgray mb-0">
                {language === "EN" ? "Discover menu" : "查看菜单"}
              </h2>
            </Col>
          </Row>
          <Tab03 data={TabData03} />
          <div className="text-center mt-28 lg:mt-20 md:mt-14 xs:mt-8">
            {/* <Buttons
              ariaLabel="view hotpot menu"
              className="btn-fill mx-auto font-medium font-serif rounded-none uppercase md:mb-[15px]"
              themeColor="#cd9452"
              color="#fff"
              size="lg"
              title={
                language === "EN"
                  ? "Updated Menu Coming Soon"
                  : "敬请期待更新菜单"
              }
            /> */}
            {/* <Buttons
              ariaLabel="view hotpot menu"
              className="btn-fill mx-auto font-medium font-serif rounded-none uppercase md:mb-[15px]"
              themeColor="#cd9452"
              color="#fff"
              size="lg"
              title="View Hotpot Menu"
              href="/assets/pdf/Broadway Hotpot Hotpot Menu.pdf"
              target="_blank"
            /> */}
          </div>
          <div className="text-center mt-28 lg:mt-20 md:mt-14 xs:mt-8">
            <Buttons
              ariaLabel="view drink menu"
              href="/assets/pdf/drink_menu.pdf"
              target="_blank"
              className="btn-fill mx-auto font-medium font-serif rounded-none uppercase md:mb-[15px]"
              themeColor="#cd9452"
              color="#fff"
              size="lg"
              title={language === "EN" ? "View Drink Menu" : "酒单"}
            />
          </div>
        </Container>
      </m.section>
      {/* Menu Highlight End */}
      {/* KTV Start */}
      <section className="p-0">
        <Container fluid>
          <Row xl={4} sm={2} xs={1}>
            <m.div
              {...fadeInUp}
              className="col mt-[3.5rem] cover-background h-[650px] px-0 lg:m-0 md:h-[500px] xs:h-[450px]"
              style={{
                backgroundImage: `url(/assets/img/ktv-4.webp)`,
              }}
            >
              <div className="absolute top-0 left-0 w-full h-full opacity-70 bg-darkgray"></div>
              <div className="flex flex-col h-full p-20 text-center relative z-[1] xl:px-12 lg:px-16">
                {/* <span className="font-serif font-medium uppercase text-[#ca943d]">
                  Karaoke
                </span> */}
                <h2 className="heading-4 font-serif font-semibold text-white uppercase mb-auto mt-auto -tracking-[.5px]">
                  {language === "EN" ? "Karaoke" : "卡拉OK"}
                </h2>
              </div>
            </m.div>
            <m.div
              {...fadeInUp}
              className="cover-background h-[650px] px-0 md:h-[500px] xs:h-[450px]"
              style={{
                backgroundImage: `url(/assets/img/ktv-2.jpg)`,
              }}
            >
              <div className="flex flex-col h-full justify-start py-20 px-24 text-center relative z-[1] xl:px-12 lg:px-32">
                <span className="font-serif font-medium uppercase text-darkgray block mb-[15px]">
                  {language === "EN"
                    ? "Let us host your next party"
                    : "您的下一场派对就在这里"}
                </span>
                <h2 className="heading-4 font-serif font-semibold text-white uppercase mb-auto mt-auto -tracking-[.5px]">
                  {language === "EN" ? "Party Your Way" : "尽情派对，随心所欲"}
                </h2>
              </div>
            </m.div>
            <m.div
              {...fadeInUp}
              className="mt-14 cover-background h-[650px] px-0 lg:m-0 md:h-[500px] xs:h-[450px]"
              style={{
                backgroundImage: `url(/assets/img/ktv-1.jpg)`,
              }}
            >
              <div className="absolute top-0 left-0 w-full h-full opacity-70 bg-darkgray"></div>
              <div className="flex flex-col h-full p-20 text-center relative z-[1] xl:px-12 lg:px-32">
                <span className="font-serif font-medium uppercase text-[#ca943d]">
                  {language === "EN"
                    ? "Our light is called wild star for a reason"
                    : "来感受一下狂野之心"}
                </span>
                <h2 className="heading-4 font-serif font-semibold text-white uppercase mb-auto mt-auto -tracking-[.5px]">
                  {language === "EN" ? "Professional Light" : "专业灯光效果"}
                </h2>
              </div>
            </m.div>
            <m.div
              {...fadeInUp}
              className="cover-background h-[650px] px-0 md:h-[500px] xs:h-[450px]"
              style={{
                backgroundImage: `url(/assets/img/ktv-3.webp)`,
              }}
            >
              <div className="flex flex-col h-full justify-start py-20 px-24 text-center relative z-[1] xl:px-12 lg:px-32">
                <span className="font-serif font-medium uppercase text-[#ca943d]">
                  {language === "EN"
                    ? "Enjoy discounted price during off peak hour"
                    : "工作日时段享受优惠价格"}
                </span>
                <h2 className="heading-4 font-serif font-semibold text-white uppercase mb-auto mt-auto -tracking-[.5px]">
                  {language === "EN" ? "Off-peak Price" : "平日优惠"}
                </h2>
              </div>
            </m.div>
          </Row>
          <Row
            className="justify-center mb-4 mt-28 lg:mt-20 md:mt-14 xs:mt-8"
            ref={karaokeRoomRef}
          >
            <m.div className="col-md-5 text-center" {...fadeIn}>
              <span className="text-xmd text-basecolor uppercase font-serif font-medium tracking-[1px] block mb-[5px]">
                {language === "EN" ? "Karaoke Happy Hour" : "卡拉OK欢乐时光"}
              </span>
              <h2 className="heading-5 font-serif font-bold uppercase text-darkgray mb-0">
                {language === "EN"
                  ? "Half Price Mon-Thu 11am till 4pm"
                  : "每周一至周四上午11点至下午4点KTV半价优惠"}
              </h2>
            </m.div>
          </Row>
          <div
            className="text-center flex flex-col mb-[5px]"
            style={{
              justifyContent: "center",
              gap: 15,
              alignItems: "center",
            }}
          >
            <div
              className="text-center flex"
              style={{
                gap: 10,
                alignItems: "center",
                width: "80%",
                justifyContent: "center",
              }}
            >
              <label for="party_size">Party Size:</label>
              <select
                className="py-[10px] px-[15px] border border-[#dfdfdf]"
                onChange={handleKaraokeRoomChange}
                style={{ width: "50%" }}
                id="party_size"
              >
                <option value="queen">1-6</option>
                <option value="king">7-20</option>
              </select>
            </div>
            <Buttons
              ariaLabel={`Reserve ${karaokeRoom} room`}
              className="btn-fill mx-auto font-medium font-serif rounded-none uppercase md:mb-[5px]"
              themeColor="#cd9452"
              color="#fff"
              size="lg"
              title={`Reserve ${karaokeRoom} room`}
              type="button"
              href={`https://calendly.com/broadway-hotpot-${karaokeRoom}-room`}
              target="_blank"
            />
            <i>
              {language === "EN"
                ? `*${karaokeRoom} room holds up to ${
                    karaokeRoom === "queen" ? 6 : 20
                  } people`
                : `*${karaokeRoom === "queen" ? "小" : "大"}包最多可供${
                    karaokeRoom === "queen" ? 6 : 20
                  }人欢唱`}
            </i>
          </div>
          <div className="text-center flex flex-col mb-[5px]">
            <CustomModal.Wrapper
              animation="fade-zoom"
              modalBtn={
                <Buttons
                  ariaLabel="View Karaoke Price"
                  className="btn-fill mx-auto font-medium font-serif rounded-none uppercase mb-[5px]"
                  themeColor="#cd9452"
                  color="#fff"
                  size="lg"
                  title="View Karaoke Price"
                  type="button"
                />
              }
            >
              <div className="w-[500px] sm:w-full justify-center">
                <div className="p-[1.5rem] relative bg-white rounded sm:px-10">
                  <div className="mx-auto text-center rounded-[6px] sm:px-[2.5rem] xs:px-0">
                    <Row className="justify-center">
                      <img
                        className="w-full max-w-full h-auto"
                        src="/assets/img/Broadway Hotpot Karaoke Price.webp"
                        alt="Karaoke Price"
                      />
                    </Row>
                  </div>
                </div>
              </div>
            </CustomModal.Wrapper>
            <i>
              {language === "EN"
                ? "*Hotpot not included. Make hotpot reservation separately. Hotpot usually takes 60-90 mins. Dine in for hotpot and get $10 off the hourly rate of karaoke room"
                : "*KTV包间不包括火锅。如有需要请另外预约火锅。请在KTV预约时间前留出60-90分钟享用火锅。如同时预定火锅及KTV，KTV房费每小时便宜$10。"}
            </i>
          </div>
        </Container>
      </section>
      {/* KTV End */}
      {/* Royalty Program Start */}
      {/* <section
        ref={royaltyRef}
        className="bg-lightgray py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]"
      >
        <Container>
          <Row className="justify-center">
            <m.div className="col-md-5 text-center mb-[4.5rem]" {...fadeIn}>
              <span className="text-xmd text-basecolor uppercase font-serif font-medium tracking-[1px] block mb-[5px]">
                {language === 'EN' ? 'amazing perks' : ''}
              </span>
              <h2 className="heading-5 font-serif font-bold uppercase text-darkgray mb-0">
                {language === 'EN' ? 'Royalty Program' : '尊享会员计划'}
              </h2>
            </m.div>
          </Row>
          <CustomIconWithText
            grid="row-cols-1 row-cols-lg-4 row-cols-sm-2 justify-center text-center gap-y-10 landscape:md:gap-y-0"
            className=""
            theme="custom-icon-with-text01"
            data={RoyaltyProgramData}
            animation={fadeIn}
          />
        </Container>
      </section> */}
      {/* Royalty Program End */}
      {/* Reservation Start */}
      <m.section
        ref={reservationRef}
        id="classes"
        className="bg-[#faf6f3] py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]"
        {...fadeIn}
      >
        <Container>
          <InfoBannerStyle01
            grid="row row-cols-1 row-cols-lg-3 row-cols-sm-2 md:gap-y-10"
            className="justify-center"
            data={ReservationSectionData}
            animation={fadeIn}
            karaokeRoomRef={karaokeRoomRef}
          />
        </Container>
      </m.section>
      {/* Reservation End */}
      {/* Instagram Start */}
      {/* <section className="z-[1] relative sm:pb-[50px]">
        <Container>
          <Row className="justify-center">
            <m.div className="col-md-12 col" {...fadeIn}>
              <Instagram
                carousel={true}
                carouselOption={{
                  loop: true,
                  slidesPerView: 2,
                  spaceBetween: 15,
                  autoplay: { delay: 3500, disableOnInteraction: false },
                  keyboard: { enabled: true, onlyInViewport: true },
                  breakpoints: {
                    1200: { slidesPerView: 6 },
                    992: { slidesPerView: 4 },
                    768: { slidesPerView: 3 },
                  },
                }}
                total_posts={8}
                title="#broadway hotpot"
                grid=""
              />
            </m.div>
          </Row>
        </Container>
      </section> */}
      {/* Instagram End */}
      {/* Footer Start */}
      <footer className="text-[#828282] py-[60px] border-t border-mediumgray md:pt-[80px] md:pb-[60px]">
        <Container>
          <Row className="items-center">
            <Col md={6} className="sm:mb-[15px]">
              <ul className="flex text-sm font-serif text-center justify-start md:justify-start sm:justify-center xs:text-center xs:flex-col">
                <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                  <a
                    aria-label="Home Link"
                    className="hover:text-[#ca943d]"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleNavClick("/#");
                    }}
                  >
                    {language === "EN" ? "Home" : "主页"}
                  </a>
                </li>
                <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                  <a
                    aria-label="About Us Link"
                    className="hover:text-[#ca943d]"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleNavClick("/about-us");
                    }}
                  >
                    {language === "EN" ? "About Us" : "关于我们"}
                  </a>
                </li>
                <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                  <a
                    aria-label="Menu Link"
                    className="hover:text-[#ca943d]"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleNavClick("/#menu");
                    }}
                  >
                    {language === "EN" ? "Menu" : "菜单"}
                  </a>
                </li>
                <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                  <a
                    aria-label="Reservation Link"
                    className="hover:text-[#ca943d]"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleNavClick("/#reservation");
                    }}
                  >
                    {language === "EN" ? "Reservation" : "预约"}
                  </a>
                </li>
              </ul>
            </Col>
            <Col md={6} className="text-center">
              <p className="text-sm uppercase flex items-center justify-center">
                © {new Date().getFullYear()} Broadway Hotpot
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
      {/* Footer End */}

      {/* Promo Modal Component Start */}
      {/* {showLandingPopup && (
        <CustomModal.Wrapper
          closeBtnIn={true}
          closeBtnOuter={false}
          defaultOpen={true}
          className="promo-modal"
          onClose={() => {
            return;
          }}
        >
          <div
            className="text-left relative landscape:md:mt-[100px]"
            id="promo-popup"
          >
            <Container>
              <Row className="justify-center">
                <Col lg={11} md={10} className="relative">
                  <div className="absolute top-0 ml-[-15px] z-10 s:left-0 xs:right-0">
                    <CustomModal.Close
                      className="close-btn text-black"
                      onClose={() => setSearchParams({})}
                    >
                      <button
                        title="Close (Esc)"
                        type="button"
                        className="border-none text-[30px] w-[44px] h-[44px]"
                      >
                        ×
                      </button>
                    </CustomModal.Close>
                  </div>
                  <Row className="justify-center">
                    <Col
                      className="p-24 lg:p-16 xs:p-[3rem] bg-white overflow-hidden"
                      sm={{ span: 7, order: 1 }}
                      xs={{ span: 12, order: 2 }}
                    >
                      <span className="text-xlg font-medium text-darkgray block mb-[10px]">
                        Happy St Patrick's Day ☘️
                      </span>
                      <p
                        className="mb-[20px] xs:mb-[10px]"
                        // onClick={() => {
                        //   handleNavClick("/#royalty-program");
                        //   setShowLandingPopup(false);
                        // }}
                        style={{ cursor: "pointer" }}
                      >
                        Enjoy $1 Selected Tap Beer 🍻 (Miller Lite, Peroni, and
                        Samuel Adams Cold Snap) ALL DAY Mar 16-17, 2025
                      </p>
                    </Col>
                    <Col
                      sm={{ span: 5, order: 2 }}
                      xs={{ span: 12, order: 1 }}
                      className="bg-cover cover-background xs:h-[150px] xs:pt-[300px]"
                      style={{
                        backgroundImage: `url('/assets/img/promoAndEvent/st-patrick.png')`,
                        backgroundPosition: "75%",
                      }}
                    ></Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </CustomModal.Wrapper>
      )} */}
      {/* Promo Modal Component End */}
      {/* Campaign Modal Component Start */}
      {utmCampaign === "HACK2025MAR" && (
        <CustomModal.Wrapper
          closeBtnIn={true}
          closeBtnOuter={false}
          defaultOpen={true}
          className="hack-2025-mar-campaign-modal"
          onClose={() => setSearchParams({})}
        >
          <div
            className="text-left relative landscape:md:mt-[100px]"
            id="hack-2025-mar-campaign-popup"
          >
            <Container>
              <Row className="justify-center">
                <Col lg={11} md={10} className="relative">
                  <div className="absolute top-0 ml-[-15px] z-10 s:left-0 xs:right-0">
                    <CustomModal.Close
                      className="close-btn text-black"
                      onClose={() => setSearchParams({})}
                    >
                      <button
                        title="Close (Esc)"
                        type="button"
                        className="border-none text-[30px] w-[44px] h-[44px]"
                      >
                        ×
                      </button>
                    </CustomModal.Close>
                  </div>
                  <Row className="justify-center">
                    <Col
                      className="p-24 lg:p-16 xs:p-[3rem] bg-white overflow-hidden"
                      sm={{ span: 7, order: 1 }}
                      xs={{ span: 12, order: 2 }}
                    >
                      <span className="text-xlg font-medium text-darkgray block mb-[10px]">
                        Happy Lunar New Year!
                      </span>
                      <p className="mb-[20px] xs:mb-[10px]">
                        Thank you BSO patrons for your support. Celebrate with
                        our Hotpot All-You-Can-Eat Special!
                      </p>
                      <p>
                        Use code{" "}
                        <pre
                          style={{
                            display: "inline",
                            padding: "0 5px",
                            fontWeight: "bold",
                          }}
                        >
                          HAPPYLNY
                        </pre>
                        : Buy 3, Get 1 Free. Promotion valid 1/22 - 2/5
                      </p>
                    </Col>
                    <Col
                      sm={{ span: 5, order: 2 }}
                      xs={{ span: 12, order: 1 }}
                      className="bg-cover cover-background xs:h-[150px] xs:pt-[300px]"
                      style={{
                        backgroundImage: `url('/assets/img/snake year.jpg')`,
                        backgroundPosition: "75%",
                      }}
                    />
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </CustomModal.Wrapper>
      )}
      {/* Campaign Modal Component End */}
    </>
  );
};

export default LandingPage;
